import {getUrlVars} from "../modules/Util";
import {limitMaximum} from "./ProductItemStore";

export default function productQuantity() {
    $('.js-store-product').each(function() {
        if (this.rendered) return;
        this.rendered = true;
        let $product = $(this);
        let $input = $product.find('.js-quantity-input');
        let $quantityPlus = $product.find('.js-quantity-plus');
        let $quantityMinus = $product.find('.js-quantity-minus');
        let $productQuantity = $product.find('.js-product-quantity');
        let inputMax = parseInt($input.data('max'));

        let currPage = window.localStorage.getItem('pageId') ? window.localStorage.getItem('pageId') : getUrlVars(window.location.href)['page'];
        $product.data('page', currPage);

        // Ищем все подобные товары на странице
        let currProductId = $product.data('product-id');

        let $productOffers = $product.find('.js-product-offers');
        if ($productOffers.length) {
            currProductId = $productOffers.find(`option[value="${$productOffers.val()}"]`).data('product-id');

            $productOffers.on('change', function() {
                currProductId = $productOffers.find(`option[value="${$productOffers.val()}"]`).data('product-id');
            });
        }

        $quantityMinus.removeClass('_disabled');
        // $currProductMinus.removeClass('_disabled');

        if (inputMax && parseInt($input.val()) >= parseInt(inputMax)) {
            $quantityPlus.addClass('_disabled');
            $input.val(inputMax);
        } else {
            $quantityPlus.removeClass('_disabled');
        }

        $quantityMinus.off('click');
        $quantityMinus.on('click', function(e) {
            e.preventDefault();

            let count = parseInt($input.val()) - 1;

            $.ajax({
                url: $productQuantity.data('url'),
                method: "GET",
                dataType: "json",
                data: {
                    'id': currProductId,
                    'quantity': count
                },
                success:  (response) => {
                    if (response.success) {
                        const $samePproducts = $(('.js-store-product[data-product-id="' + currProductId + '"]')).not($product);

                        if (count <= 1) {
                            count = 1;
                            $(this).addClass('_disabled');
                            $quantityMinus.addClass('_disabled');
                            $samePproducts.find('.js-quantity-minus').addClass('_disabled');
                        }

                        if (response.quantity == 0) {
                            $('.js-header-basket').addClass('header-basket--empty');
                        }

                        $('.js-basket-quantity').html(limitMaximum(response.quantity));

                        $input.val(count);
                        $input.change();
                        $quantityPlus.removeClass('_disabled');
                        $samePproducts.find('.js-quantity-input').val(count).change();
                        $samePproducts.find('.js-quantity-plus').removeClass('_disabled');
                        $($productOffers.find(`option[value="${$productOffers.val()}"]`)).attr('data-in-basket', count);
                    };
                },
                error: () => {
                    console.log('Ошибка получения данных');
                }
            });
        });

        $quantityPlus.off('click');
        $quantityPlus.on('click', function(e) {
            e.preventDefault();

            let count = parseInt($input.val()) + 1;

            $.ajax({
                url: $productQuantity.data('url'),
                method: "GET",
                dataType: "json",
                data: {
                    'id': currProductId,
                    'quantity': count
                },
                success:  (response) => {
                    if (response.success) {
                        const $samePproducts = $(('.js-store-product[data-product-id="' + currProductId + '"]')).not($product);

                        $input.val(count);
                        $input.change();
                        $quantityMinus.removeClass('_disabled');
                        $samePproducts.find('.js-quantity-input').val(count).change();
                        $samePproducts.find('.js-quantity-minus').removeClass('_disabled');
                        $($productOffers.find(`option[value="${$productOffers.val()}"]`)).attr('data-in-basket', count);

                        if (count >= inputMax) {
                            $(this).addClass('_disabled');
                            $quantityPlus.addClass('_disabled');
                            $samePproducts.find('.js-quantity-plus').addClass('_disabled');
                        }
                    };
                },
                error: () => {
                    console.log('Ошибка получения данных');
                }
            });
        });
    });
};

App.D.ready(productQuantity);
